import { useSuspenseQuery } from '@tanstack/react-query';
import { SourcingService } from 'api-clients/monolith';
import _range from 'lodash/range';
import { Fragment } from 'react';
import { useIntl } from 'react-intl';

import IllustrationIcon from '@/assets/icons/illustration.svg';
import { EmptyState } from '@/components/ui/empty-state';
import { queryKeys } from '@/query-keys';

import { OpeningItem } from './opening-item';

export function OpeningsList() {
  const intl = useIntl();

  const {
    data: { data: openingsAtRisk },
  } = useSuspenseQuery({
    queryKey: [...queryKeys.dashboard.recommendations.atRiskOpenings],
    queryFn: () =>
      SourcingService.getInternalApiSourcingDashboardOpeningsAtRisk(),
  });

  /* Empty state */
  if (openingsAtRisk.length === 0)
    return (
      <EmptyState
        icon={IllustrationIcon}
        header={intl.formatMessage({
          defaultMessage: 'All caught up!',
          description:
            'Empty state headline when nothing in the Action center needs work',
        })}
        description={intl.formatMessage({
          defaultMessage:
            "No actions needed right now. We'll surface new recommendations here when your openings need attention.",
          description:
            'Supporting copy reassuring the user recommendations will appear when relevant',
        })}
      />
    );

  return (
    <div className="flex flex-col gap-4 overflow-y-auto p-4 pt-0">
      {openingsAtRisk.map((opening, index) => (
        <Fragment key={opening.external_id}>
          <OpeningItem opening={opening} isFirst={index === 0} />
          {index !== openingsAtRisk.length - 1 && (
            <div className="bg-fx-neutral-200 h-px w-full shrink-0" />
          )}
        </Fragment>
      ))}
    </div>
  );
}

OpeningsList.Skeleton = function OpeningsListSkeleton() {
  return (
    <div className="flex flex-col gap-4 overflow-y-auto p-4 pt-0">
      {_range(10).map(index => (
        <Fragment key={index}>
          <OpeningItem.Skeleton />
          <div className="bg-fx-neutral-200 h-px w-full shrink-0" />
        </Fragment>
      ))}
    </div>
  );
};
